import { PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT } from "core/schemas/shared";
import { padding } from "ds_legacy/materials/metrics";
import {
  PatientFormSubheading,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";

export const SectionZero = () => {
  const translations = useTranslations();

  return (
    <Section>
      <SectionRow style={{ flexWrap: "nowrap" }}>
        <TextInputWithLabel
          bold
          characterLimit={PENSION_INSURANCE_NUMBER_CHARACTER_LIMIT}
          elementName="statutory_pension_insurance_number"
          label={
            translations.patientForms.drvGeneralForm.insuranceInformation
              .pensionInsuranceNumber
          }
          labelWrapperSx={{ width: "30%" }}
        />
        <TextInputWithLabel
          bold
          elementName="pension_insurance_company_name"
          label={
            translations.patientForms.drvGeneralForm.insuranceInformation
              .addressPensionInsurance
          }
          labelWrapperSx={{ width: "70%" }}
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="insurance_company_name_address"
          label={
            translations.patientForms.drvGeneralForm.insuranceInformation
              .addressHealthInsurance
          }
          labelWrapperSx={{ width: "100%" }}
        />
      </SectionRow>
      <PatientFormSubheading>
        {
          translations.patientForms.drvGeneralForm.insuranceInformation
            .subtitleHospital
        }
      </PatientFormSubheading>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          bold
          elementName="hospital_name_address"
          label={
            translations.patientForms.drvGeneralForm.insuranceInformation
              .addressHospital
          }
          labelWrapperSx={{ width: "100%" }}
        />
      </SectionRow>
      <PatientFormSubheading>
        {
          translations.patientForms.drvGeneralForm.insuranceInformation
            .subtitleSocialWorker
        }
      </PatientFormSubheading>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          bold
          elementName="social_worker_name_number"
          label={
            translations.patientForms.drvGeneralForm.insuranceInformation
              .informationSocialWorker
          }
          labelWrapperSx={{ width: "100%" }}
        />
      </SectionRow>
      <PatientFormSubheading>
        {
          translations.patientForms.drvGeneralForm.insuranceInformation
            .subtitleRehabClinic
        }
      </PatientFormSubheading>
      <SectionRow customPadding={padding(1, 0, 0)}>
        <TextInputWithLabel
          bold
          elementName="preferred_rehab_clinic"
          label={
            translations.patientForms.drvGeneralForm.insuranceInformation
              .informationAhbFacility
          }
          labelWrapperSx={{ width: "100%" }}
        />
      </SectionRow>
    </Section>
  );
};
